import React, { useState } from "react";
import QuizComponent from "./QuizComponent";
import Modal from "react-modal";
import "./QuizzesList.css";
import AddQuizComponent from "./AddQuizComponent";
import { VscIssueReopened } from "react-icons/vsc";

const QuizzesList = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  // for quiz record


  return (
    <div className="quizzes-list-body">
      <div className="quizzes-list-buttons">
        <button
          style={{
            background: "none",
            border: "none",
            marginRight: "30px",
            cursor: "pointer",
          }}
          onClick={() => window.location.reload()}
        >
          <VscIssueReopened size={20} color="gray" />
        </button>
        <button
          onClick={() => setModalIsOpen(true)}
          className="add-question-cta"

        >
          Add quiz
        </button>
      </div>
      <Modal
        closeTimeoutMS={200}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          content: {
            position: "absolute",

            width: "50%",
            height: "80%",

            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            outline: "none",
            padding: "35px",
            paddingLeft: "45px",

            border: "0",
            bottom: "auto",
            minHeight: "10rem",
            left: "50%",
            position: "fixed",
            right: "auto",
            top: "50%",
            transform: "translate(-50%,-50%)",
            minWidth: "20rem",
            maxWidth: "60rem",
          },
        }}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
      >
        <AddQuizComponent setModalIsOpen={setModalIsOpen} />
      </Modal>
      <div className="qzl-titles">
        <div className="qzl-name">Name</div>
        <div className="qzl-dbname">DB Name</div>
        <div className="qzl-passing-score">Pass Score</div>
        <div className="qzl-questions">Questions</div>
        <div className="qzl-description">Desciption</div>
        <div className="qzl-category">Category</div>
        <div className="qzl-avg-rating">Avg Rating</div>
        <div className="qzl-live">Live</div>
        <div className="qzl-questions-per-entry">Question/entry</div>
        <div className="qzl-times-taken">Times Taken</div>
        <div className="qzl-image-url">Img URL</div>
      </div>
      <div className="quizzes-list">
        {props.quizzes.map((quiz) => (
          <QuizComponent
          // key={quiz.quiz}
            quiz={quiz.quiz}
            name={quiz.name}
            passingScore={quiz.passingScore}
            questions={quiz.questions}
            description={quiz.description}
            category={quiz.category}
            averageRating={quiz.averageRating}
            live={quiz.live}
            questionsPerEntry={quiz.questionsPerEntry}
            timesTaken={quiz.timesTaken}
            imageUrl={quiz.imageURL}
          />
        ))}
      </div>
    </div>
  );
};

export default QuizzesList;
